import React, { useState } from 'react';
import { Card, CardHeader, CardContent, IconButton, Collapse } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import PropTypes from 'prop-types';
import styles from 'styles/components/modelMaster.module.scss';
import ModelSpecs from 'components/modelSpecs';
import ModelPrices from 'components/modelPrices';
import ModelTrims from 'components/modelTrims';
import { Alert } from '@material-ui/lab';
import Link from 'components/link';

const ModelMaster = ({ model, selectedVersions }) => {
    const [alertOpen, setAlertOpen] = useState(true);
    return (
        <>
            <Card className={styles.root}>
                <CardHeader title={<h2>Caractéristiques techniques</h2>} />
                <CardContent className={styles.cardContent}>
                    <ModelSpecs versions={selectedVersions} />
                </CardContent>
            </Card>
            <Card className={styles.root}>
                <CardHeader title={<h2>Équipements</h2>} />
                <CardContent className={styles.cardContent}>
                    <ModelTrims versions={selectedVersions} />
                </CardContent>
            </Card>
            <Card className={styles.root}>
                <CardHeader title={<h2>Évolution prix & promotion</h2>} />
                <CardContent>
                    <Collapse in={alertOpen}>
                        <Alert
                            style={{ maxWidth: 500, margin: '0 auto', textAlign: 'left' }}
                            variant="filled"
                            severity="info"
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => setAlertOpen(false)}
                                >
                                    <Close fontSize="inherit" />
                                </IconButton>
                            }
                        >
                            <>
                                <p>
                                    {`Indicateur de l'évolution du prix du modèle
                                            pendant les 12 derniers mois.`}
                                </p>
                                <p>Les prix et promo concernent les versions de base.</p>
                                <p>
                                    {`Notez qu'il se peut que cettes versions aussi
                                            bien que leurs caractéristiques et dotations
                                            aient été modifiées pendant cette période.`}
                                </p>
                                <p>Utilisez ceci à titre indicatif seulement.</p>
                                <p>
                                    Encore des doutes?{' '}
                                    <Link href="/contact">contactez-nous</Link>
                                </p>
                            </>
                        </Alert>
                    </Collapse>
                    <div className={styles.chart}>
                        <ModelPrices model={model} />
                    </div>
                </CardContent>
            </Card>
        </>
    );
};

ModelMaster.propTypes = {
    model: PropTypes.object.isRequired,
    selectedVersions: PropTypes.array.isRequired,
};

export default ModelMaster;
